export default __webpack_public_path__ + "static/media/AUD.d0e6f1c4.svg";